import lodash from "lodash";
import type {
  ConfigType
} from "./ADMIN";
import * as ADMIN from "./ADMIN";

function _init() {
  const {
    _default,
    devLocal,
    devDev,
    devQa,
    devStage,
    devProd,
    prodDev,
    prodQa,
    prodStage,
    prodProd
  } = ADMIN;

  const mapping: any = {
    development: {
      local: devLocal,
      dev: devDev,
      qa: devQa,
      stage: devStage,
      prod: devProd
    },
    production: {
      dev: prodDev,
      qa: prodQa,
      stage: prodStage,
      prod: prodProd
    },
  };

  const nodeGroup = mapping[process.env.NODE_ENV ?? "development"];
  if (nodeGroup == null) {
    console.warn(
      `Can not find configs for current NODE_ENV(${process.env.NODE_ENV}), will use default configs`
    );
    return _default;
  }

  let overrided = nodeGroup[process.env.REACT_APP_ARES_ENV || ""];
  if (overrided == null) {
    console.warn(
      `Can not find configs for current REACT_APP_ARES_ENV(${process.env.REACT_APP_ARES_ENV}), will use ${process.env.NODE_ENV}-default configs`
    );
    overrided = nodeGroup.default;
  }

  return lodash.cloneDeep(
    lodash.merge(_default as any, overrided as any) as ConfigType
  );
}

export function initConfig() {
  const c = _init();

  (window as any).config = c;

  return c;
}

export function config(forceRenew: boolean = false) {
  let c = (window as any).config;
  if (c == null || forceRenew) {
    c = initConfig();
  }

  return c as ConfigType;
}





